import Cta from '@/components/shared/JoinCTA';
import { Flex, font, themedColor } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import parse from 'html-react-parser';
import styled from 'styled-components';
import type { Item } from '../index';

const CardPrice = styled(Flex).attrs({
  as: 'li',
})`
  ${font('main')};
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  padding: 29px 38px;
  border-radius: 12px;
  margin: 20px;
  text-align: center;
  width: 320px;
  background: ${themedColor('cloud')};
  box-shadow: 0px 47px 46px -27px rgba(0, 0, 0, 0.16);

  ${MEDIA_QUERIES.tabletAndDesktop`
    margin-bottom: 50px;
  `}

  a {
    display: block;
    width: 100%;
  }
`;

const CardTitle = styled.span`
  display: block;
  text-wrap: balance;
  ${font('main', { fontSize: '3rem', lineHeight: '3rem' })};
  text-align: center;
  white-space: pre;
`;

const CardSubtitle = styled.span`
  display: block;
  ${font('main', { fontSize: '1.4rem', lineHeight: 1.3 })};
  color: ${themedColor('metal')};
  text-transform: uppercase;
  margin-top: 20px;
`;

const CardPriceDetails = styled.em`
  ${font('alt', { fontSize: '5.8rem', lineHeight: '7.3rem', fontWeight: 500 })};
  margin-top: 20px;
  margin-bottom: 30px;
`;

interface PriceCardProps {
  readonly item: Item;
}

export const PriceCard: React.FC<PriceCardProps> = ({ item }) => {
  return (
    <CardPrice key={item.title} tabIndex={0}>
      <CardTitle>{parse(item.title)}</CardTitle>
      <CardSubtitle>{item.subtitle}</CardSubtitle>
      <CardPriceDetails>{item.price}</CardPriceDetails>
      <Cta flavor="primary" glowing customUrl={item.cta.ctaUrl}>
        {item.cta.ctaLabel}
      </Cta>
    </CardPrice>
  );
};
